import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UsersApiService} from '../services/users.api.service';
import {EventsService} from '@services/events.service';
import {AuthService} from '@services/auth.service';
import {OrganizationUserNamespace} from '@namespaces/organization-user.namespace';
import InvitedUserInterface = OrganizationUserNamespace.InvitedUserInterface;
import {UserNamespace} from '@namespaces/user.namespace';

@Component({
    selector: 'app-users-list',
    templateUrl: 'users-list.component.html'
})

export class UsersListComponent implements OnInit {

    activeUsers: InvitedUserInterface[] = [];
    invitedUsers: InvitedUserInterface[] = [];
    blockedUsers: InvitedUserInterface[] = [];

    permissions = UserNamespace.Permission;

    constructor(
        private route: ActivatedRoute,
        private usersApi: UsersApiService,
        private eventsService: EventsService,
        private authService: AuthService,
    ) {
    }

    ngOnInit() {
        const users: InvitedUserInterface[] = this.route.snapshot.data.users;
        const currentUser = this.authService.user$.getValue();
        const currentInList = users.find(user => user.id === currentUser.id);

        if (currentInList) {
            currentInList.isCurrent = true;
        }

        if (users && users.length) {
            this.activeUsers = this.getSortedList(users.filter(user => (user.active === true && user.blocked === false)));
            this.invitedUsers = this.getSortedList(users.filter(user => (user.active === false && user.blocked === false)));
            this.blockedUsers = this.getSortedList(users.filter(user => user.blocked === true));
        }
    }

    blockUser(user: InvitedUserInterface) {
        this.usersApi.get({
            url: this.usersApi.blockUserUrl,
            queryParams: {
                id: user.id
            }
        }).toPromise().then(() => {
            this.activeUsers.splice(this.activeUsers.indexOf(user), 1);
            this.blockedUsers = this.getSortedList([user].concat(this.blockedUsers));
            this.eventsService.notyShow$.next({
                content: `Пользователь ${user.name} заблокирован`,
                type: 'success',
            });
        }, () => {

        });
    }

    inviteUser(user: InvitedUserInterface) {
        this.usersApi.get({
            url: this.usersApi.repeatInviteUserUrl,
            queryParams: {
                id: user.id
            }
        }).toPromise().then(() => {
            this.eventsService.notyShow$.next({
                content: `Повторное приглашение отправлено на email ${user.email}`,
                type: 'success',
            });
        }, () => {

        });
    }

    activateUser(user: InvitedUserInterface) {
        this.usersApi.get({
            url: this.usersApi.activateUserUrl,
            queryParams: {
                id: user.id
            }
        }).toPromise().then(() => {
            this.blockedUsers.splice(this.blockedUsers.indexOf(user), 1);
            this.activeUsers = this.getSortedList([user].concat(this.activeUsers));
            this.eventsService.notyShow$.next({
                content: `Пользователь ${user.name} разблокирован`,
                type: 'success',
            });
        }, () => {

        });
    }

    getSortedList(users: InvitedUserInterface[] = []): InvitedUserInterface[] {
        return users.sort((a, b) => {
            return a.name <= b.name ? -1 : 1;
        });
    }
}
